import { render } from "./ColorPicker.vue?vue&type=template&id=b7a22d3c&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&lang=js"
export * from "./ColorPicker.vue?vue&type=script&lang=js"

import "./ColorPicker.vue?vue&type=style&index=0&id=b7a22d3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b7a22d3c"

export default script